import React, {useEffect, useRef, useState} from 'react';
import {useFormikContext} from "formik";

export function MyMapComponentIFrame({countries}) {
    const {values} = useFormikContext()
    const [coords, setCoords] = useState("Italy")

    useEffect(() => {

        const timeoutId = setTimeout(() => {
            const countryName = countries.find(c => c.code === values.country)?.name || ""
            if (values.city === "" && countryName !== "") {
                setCoords(encodeURIComponent(countryName))
            } else if (values.city !== "" && countryName !== "") {
                setCoords(encodeURIComponent(`${values.city}, ${values.country}`))
            } else {
                setCoords("Italy")
            }
        }, 500)

        return () => clearTimeout(timeoutId);
    }, [values.city, values.country]);


    if (!coords) return;

    return <>
        <div className="mt-4">
            <iframe
                src={`https://www.google.com/maps?q=${coords}&output=embed`}
                title="map"
                style={{
                    width: "100%",
                    height: "500px",
                    border: "none"
                }}
                loading="lazy" referrerPolicy="no-referrer-when-downgrade">

            </iframe>
        </div>

    </>
}